import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import type { RequestProps } from '../../models';

const style = { divider: { borderBottomWidth: 1.5 } };

interface CandidateInfoProps {
	candidate: RequestProps['candidate'];
}

export const CandidateInfo: React.FC<CandidateInfoProps> = ({ candidate }) => (
	<>
		<CardHeader title="Candidate Information" />
		<Divider sx={style.divider} />
		<CardContent>
			<Grid container spacing={2}>
				<Grid size={{ xs: 6 }}>
					<Typography variant="subtitle1" gutterBottom>
						First Name
					</Typography>
					<Typography variant="body1" gutterBottom>
						{candidate?.firstname}
					</Typography>
				</Grid>
				<Grid size={{ xs: 6 }}>
					<Typography variant="subtitle1" gutterBottom>
						Last Name
					</Typography>
					<Typography variant="body1" gutterBottom>
						{candidate?.lastname}
					</Typography>
				</Grid>
			</Grid>
		</CardContent>
	</>
);
